// /src/utils/axios.js
import axios from 'axios';
import { clearAuthToken, getAuthToken } from './authStorage';
// Define the base URL for all your requests
const baseURL = process.env.REACT_APP_API_URL;

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    Authentication:'f7f409e89a52c86a0fd3f168782be154'
  },
});

// Add a request interceptor to add the authorization token when required
axiosInstance.interceptors.request.use((config) => {
  const token = getAuthToken();
  
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  
  return config;
}, (error) => {
  return Promise.reject(error);
});

let isRedirecting = false;

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response && [401, 403].includes(error.response.status)) {
      if (!isRedirecting) {
        isRedirecting = true;
        clearAuthToken();
        window.location.replace('/');
      }
    }

    return Promise.reject(error);
  }
);
export default axiosInstance;
